import { Images } from "@/constants/images"
import type { SiteId } from "@/sites/config"

type Config = {
  FOOTER_PAGE_ID: {
    en: number
    vi: number
    cs: number
  }
  FOOTER_TEMPLATE_ID: {
    en: number
    vi: number
    cs: number
  }
  HEADER_PAGE_ID: {
    vi: number
    en: number
    cs: number
  }
  HEADER_TEMPLATE_ID: {
    vi: number
    en: number
    cs: number
  }
  HEADER_BANNER_ID?: number
  DEFAULT_SLUG: {
    vi: string
    en: string
    cs: string
  }
  BASE_URL: string | undefined
}

export function getConfigs(siteId: SiteId): Config {
  switch (siteId) {
    case "tamdamedia.eu":
      return {
        FOOTER_PAGE_ID: {
          en: 6,
          vi: 6,
          cs: 6,
        },
        FOOTER_TEMPLATE_ID: {
          en: 68,
          vi: 68,
          cs: 68,
        },
        HEADER_PAGE_ID: {
          vi: 2,
          en: 9,
          cs: 10,
        },
        HEADER_TEMPLATE_ID: {
          vi: 9,
          en: 9,
          cs: 10,
        },
        HEADER_BANNER_ID: 10,
        DEFAULT_SLUG: {
          vi: "homepage-vi",
          en: "homepage-en",
          cs: "homepage-cs",
        },
        BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
      }
    case "tamdagroup.eu":
      return {
        FOOTER_PAGE_ID: {
          en: 15,
          vi: 5,
          cs: 16,
        },
        FOOTER_TEMPLATE_ID: {
          en: 150,
          vi: 86,
          cs: 151,
        },
        HEADER_PAGE_ID: {
          vi: 3,
          en: 12,
          cs: 13,
        },
        HEADER_TEMPLATE_ID: {
          vi: 82,
          en: 12,
          cs: 13,
        },
        DEFAULT_SLUG: {
          vi: "trang-chu-tamda-one",
          en: "trang-chu-tamda-one-en",
          cs: "trang-chu-tamda-one-cs",
        },
        BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
      }
    default:
      return {
        FOOTER_PAGE_ID: {
          en: 169,
          vi: 205,
          cs: 205,
        },
        FOOTER_TEMPLATE_ID: {
          en: 68,
          vi: 68,
          cs: 68,
        },
        HEADER_PAGE_ID: {
          vi: 19,
          en: 16,
          cs: 16,
        },
        HEADER_TEMPLATE_ID: {
          vi: 9,
          en: 9,
          cs: 9,
        },
        DEFAULT_SLUG: {
          vi: "homepage-vi",
          en: "homepage-en",
          cs: "homepage-cs",
        },
        BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
      }
  }
}

export const languages = [
  { code: "en", label: "English", shortLabel: "EN", logo: Images.logoEn, href: "/en" },
  { code: "vi", label: "Tiếng Việt", shortLabel: "VN", logo: Images.logoVi, href: "/" },
  { code: "cs", label: "Česky", shortLabel: "CS", logo: Images.logoCs, href: "/cs" },
]
